import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { closeMiniApp } from '@telegram-apps/sdk-react';
import ErrorModal from '@components/dialogs/ErrorModal.component.jsx';
import Page from '@components/shared/Page.component.jsx';
import EventLayout from '@layouts/Event.layout.jsx';

export default function GeneralError({
  showPreloader,
  errorText,
  onButtonClick,
  onSecondaryButtonClick,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const reload = () => navigate('/');
  const close = () => closeMiniApp();

  return (
    <Page>
      <EventLayout showPreloader={showPreloader} hideButtonsImmediately={true}>
        <ErrorModal
          header={t('common.error.title')}
          description={errorText ?? t('common.error.description')}
          buttonText={t('common.error.button')}
          secondaryButtonText={t('common.close')}
          onButtonClick={onButtonClick ?? reload}
          onSecondaryButtonClick={onSecondaryButtonClick ?? close}
        />
      </EventLayout>
    </Page>
  );
}
